import {Card} from './Card'
const data = require('../../config/cards.json')['Forest']

export default class Forest extends Card {
	constructor() {
		super(data)
	}

	/**
	 * Give one coin to player
	 */
	activate() {
		this.owner.coins++
	}
}
